// FAQ accordions (.faq-accordion): one question open at a time, the others
// sliding shut. jQuery's slide animations are kept because the Sass and the
// feel of the site were tuned against them.
import $ from "../jquery-setup.js";

const OPEN = "faq-accordion--active";
const ROTATED = "faq-accordion__arrow--rotate";

export function mountFaq({ root }) {
  const titles = root.querySelectorAll(".faq-accordion__title");
  if (!titles.length) return;

  titles.forEach((title) => {
    title.addEventListener("click", (event) => {
      event.preventDefault();
      const $title = $(title);
      if (!$title.hasClass(OPEN)) {
        $(root).find(".faq-accordion__content").slideUp(200);
        $(root).find(".faq-accordion__title").removeClass(OPEN);
        $(root).find(".faq-accordion__arrow").removeClass(ROTATED);
      }
      $title.toggleClass(OPEN);
      $title.next().slideToggle(200);
      $title.find(".faq-accordion__arrow").toggleClass(ROTATED);
    });
  });
  // The listeners live on elements inside the container and go with it.
}
